import Styled from 'styled-components';

import { Button, IButtonProps } from '../Button';

export const UploadBrowseLabel = Styled(Button)<IButtonProps>`
  margin-bottom: 1em;
`;
UploadBrowseLabel.displayName = 'UploadBrowseLabel';
